var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0c10.493 0 19 8.507 19 19s-8.507 19-19 19S0 29.493 0 19 8.507 0 19 0zm0 2C9.626 2 2 9.626 2 19c0 9.374 7.626 17 17 17 9.374 0 17-7.626 17-17 0-9.374-7.626-17-17-17zm6.6 7c.784 0 1.559.543 1.865 1.286l.055.151 1.436 4.572.022-.005L29 15h2a1 1 0 01.117 1.993L31 17h-1.481l.002.027c.786.121 1.403.786 1.472 1.616L31 18.8v6.4c0 .942-.701 1.719-1.591 1.794l-.142.006H29v1a1 1 0 01-.883.993L28 29h-4a1 1 0 01-.993-.883L23 28v-1h-8v1a1 1 0 01-.883.993L14 29h-4a1 1 0 01-.993-.883L9 28v-1h-.267c-.908 0-1.655-.73-1.727-1.653L7 25.2v-6.4c0-.902.644-1.644 1.479-1.773l.001-.014.001-.013H7a1 1 0 01-.117-1.993L7 15h2l.022.004.022.005 1.436-4.571c.242-.769.983-1.36 1.764-1.43L12.4 9h13.2zM29 19H9v6h20v-6zm-3.5 2a1.501 1.501 0 11-1.5 1.501c0-.828.673-1.501 1.5-1.501zm-13 0a1.501 1.501 0 11-1.5 1.501c0-.828.673-1.501 1.5-1.501zm-.1-10l-1.884 6h16.968l-1.873-5.963L12.4 11z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconTransportCar;